module.exports = __webpack_public_path__ + "static/wiczlino4-e4b175ef11f0465e24e01e4957f1ad4f.jpg";